import { type ReactElement, type ReactNode } from 'react';
import { ReactComponent as ChevronIcon } from 'assets/icons/chevron.svg';

import styles from './scss/TargetedMarketing.module.scss';

interface IWatchTowerFoldPanel {
  id: string,
  title: string,
  open: boolean,
  onToggle: () => void,
  children: ReactNode,
}

function WatchTowerFoldPanel({
  id, title, open, onToggle, children,
}: IWatchTowerFoldPanel): ReactElement {
  return (
    <div className={styles.fold}>
      <button
        type="button"
        className={styles.foldHeader}
        aria-expanded={open}
        aria-controls={id}
        onClick={onToggle}
      >
        <span className={styles.foldTitle}>{title}</span>
        <span
          className={open ? `${styles.foldIcon} ${styles.foldIconOpen}` : styles.foldIcon}
          aria-hidden
        >
          <ChevronIcon />
        </span>
      </button>
      <div id={id}>
        {open ? <div className={styles.foldBody}>{children}</div> : null}
      </div>
    </div>
  );
}

export default WatchTowerFoldPanel;
